export var isProduction = process.env.NODE_ENV === 'production';
export var isDev = process.env.NODE_ENV === 'development';
export var isStaging = process.env.NODE_ENV === 'staging';
export var penguins_env = process.env.PENGUINS_ENV_TYPE;
export var GTAG_MEASUREMENT_ID = process.env.GTAG_MEASUREMENT_ID;
export var siteRoot = isDev ? 'http://localhost:8000' : '';
export var staticRoot = isDev ? "".concat(siteRoot, "/static/images") : '';
export var imageRoot = isDev ? staticRoot : '/wm/images';
export var penguinsProd = penguins_env === 'production';
export var penguinsStaging = penguins_env === 'staging';
export var shopRoot = penguinsProd ? 'https://shop.directbuy.com' : penguinsStaging ? 'https://dbuystage.myshopify.com' : 'http://localhost:8000';